import { ACTIVE_ORDER_STATUS_CRITERIA } from '~/pages/Cabinet/constants';

export const HEADER_ORDER_STATUSES = [
  ...ACTIVE_ORDER_STATUS_CRITERIA,
  'ready_for_pickup',
];

export const OBSERVER_KEY = 'header.orderList';
export const MAX_ORDERS_COUNT = 4;
